import React, { useMemo } from "react";
import { Heart } from "lucide-react";

// Glowing red hearts that float upward across the scene.
export const FloatingHearts = ({ count = 14, area = "full" }) => {
  const hearts = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        bottom: Math.random() * (area === "bottom" ? 25 : 70),
        size: 10 + Math.random() * 22,
        delay: Math.random() * 6,
        duration: 5 + Math.random() * 5,
        opacity: 0.5 + Math.random() * 0.5,
      })),
    [count, area]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {hearts.map((h) => (
        <span
          key={h.id}
          className="absolute"
          style={{
            left: `${h.left}%`,
            bottom: `${h.bottom}%`,
            animation: `float-up ${h.duration}s ease-in ${h.delay}s infinite`,
          }}
        >
          <Heart
            style={{
              width: h.size,
              height: h.size,
              color: "#ff5a6e",
              filter: "drop-shadow(0 0 8px rgba(255,90,110,0.85))",
              opacity: h.opacity,
            }}
            fill="#ff5a6e"
          />
        </span>
      ))}
    </div>
  );
};
